// store.js
import { createStore } from 'vuex';

import app from './modules/app';
import auth from './modules/auth';
import ui from './modules/ui';
import headerFilter from './modules/headerFilter';
import localization from './modules/localization';

// ✅ Dynamische Module-Objekt erstellen
const modules = {
  app,
  auth,
  localization,
  ui,
  headerFilter
};

if (process.env.VUE_APP_TARGET === 'bmw' || APP_TARGET === 'bmw') {
  const bmw = require('./modules/clientData-bmw').default;
  modules.clientData = bmw;
} else {
  const clientData = require('./modules/clientData').default;
  modules.clientData = clientData;
};

export default createStore({
  modules
});
